import { faReact } from '@fortawesome/free-brands-svg-icons';
import { faFileCode, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../Tabs.css';
import Contact from './Tabs/Contact';
import Home from './Tabs/Home';
import Skills from './Tabs/Skills';

function Tabs({ activeTab, onTabChange }) {
	const handleTabClick = (tabIndex) => {
		onTabChange(tabIndex);
	};

	return (
		<main>
			<div className="tab-container">
				<div
					className={`tab ${activeTab === 0 ? 'active' : ''}`}
					onClick={() => handleTabClick(0)}
				>
					<FontAwesomeIcon icon={faReact} style={{ color: '#5CCFEE' }} />
					home.jsx
				</div>

				<div
					className={`tab ${activeTab === 1 ? 'active' : ''}`}
					onClick={() => handleTabClick(1)}
				>
					<FontAwesomeIcon icon={faFileCode} style={{ color: '#CBCA00' }} />
					stack.json
				</div>

				<div
					className={`tab ${activeTab === 2 ? 'active' : ''}`}
					onClick={() => handleTabClick(2)}
				>
					<FontAwesomeIcon icon={faPaperPlane} style={{ color: '#3178C6' }} />
					contact.ts
				</div>
			</div>

			<div className="content-container">
				<div className={`content ${activeTab === 0 ? 'active' : ''}`}>
					<Home onTabChange={onTabChange} />
				</div>

				<div className={`content ${activeTab === 1 ? 'active' : ''}`}>
					<Skills />
				</div>

				<div className={`content ${activeTab === 2 ? 'active' : ''}`}>
					<Contact />
				</div>
			</div>
		</main>
	);
}

export default Tabs;
